import { Endpoints, EnvironmentUrls } from 'Roblox';
import avatarModule from '../avatarModule';

function avatarService($log, httpService, avatarUrlConstants) {
  'ngInject';

  const avatarDomain = EnvironmentUrls.avatarApi;
  const catalogDomain = EnvironmentUrls.catalogApi;

  const avatarApiUrls = avatarUrlConstants.avatarApi;
  const catalogApiUrls = avatarUrlConstants.catalogApi;

  const wwwUrls = avatarUrlConstants.www;

  function avatarApi(url, pathParams) {
    return avatarDomain + Endpoints.generateAbsoluteUrl(url, pathParams, true);
  }

  function catalogApi(url, pathParams) {
    return catalogDomain + Endpoints.generateAbsoluteUrl(url, pathParams, true);
  }

  return {
    avatarApi(url, pathParams) {
      return this.avatarDomain + Endpoints.generateAbsoluteUrl(url, pathParams, true);
    },
    getOutfitDetails(userOutfitId) {
      let url = avatarApi(avatarApiUrls.getOutfitDetailsUrl, { id: userOutfitId });

      let config = {
        url
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    createOutfit(name, bodyColors, assetIds) {
      let url = avatarApi(avatarApiUrls.createOutfitUrl);

      let config = {
        url,
        withCredentials: true
      };

      let params = {
        name,
        bodyColors,
        assetIds
      };

      return httpService.httpPost(config, params);
    },

    patchOutfit(userOutfitId, outfitContents) {
      $log.debug('Patch outfit');
      let url = avatarApi(avatarApiUrls.patchOutfitUrl, { id: userOutfitId });

      let config = {
        url,
        withCredentials: true
      };

      return httpService.httpPatch(config, outfitContents);
    },

    deleteOutfit(userOutfitId) {
      let url = avatarApi(avatarApiUrls.deleteOutfitUrl, { id: userOutfitId });

      let config = {
        url,
        withCredentials: true
      };
      let params = {};
      return httpService.httpPost(config, params);
    },

    getOutfits(userId, pageNumber, itemsPerPage, isEditable) {
      let url = avatarApi(avatarApiUrls.getOutfitsUrl, { userId });

      let config = {
        url,
        retryable: true
      };
      let params = {
        itemsPerPage,
        page: pageNumber,
        isEditable
      };
      return httpService.httpGet(config, params);
    },

    setBodyColors(bodyColors) {
      let url = avatarApi(avatarApiUrls.setBodyColorsUrl);

      let config = {
        url,
        withCredentials: true
      };
      return httpService.httpPost(config, bodyColors);
    },

    setWearingAssets(assetIds) {
      let url = avatarApi(avatarApiUrls.setWearingAssetsUrl);

      let config = {
        url,
        withCredentials: true
      };
      let params = { assetIds };
      return httpService.httpPost(config, params);
    },

    wearAsset(assetId) {
      let url = avatarApi(avatarApiUrls.wearAssetUrl, { id: assetId });

      let config = {
        url,
        withCredentials: true
      };
      let params = {};
      return httpService.httpPost(config, params);
    },

    removeAsset(assetId) {
      let url = avatarApi(avatarApiUrls.removeAssetUrl, { id: assetId });

      let config = {
        url,
        withCredentials: true
      };
      let params = {};
      return httpService.httpPost(config, params);
    },

    wearOutfit(userOutfitId) {
      let url = avatarApi(avatarApiUrls.wearOutfitUrl, { id: userOutfitId });

      let config = {
        url,
        withCredentials: true
      };
      let params = {};
      return httpService.httpPost(config, params);
    },

    getAvatar(retry) {
      if (typeof retry === 'undefined') {
        retry = true;
      }
      let url = avatarApi(avatarApiUrls.getAvatarUrl);

      let config = {
        url,
        withCredentials: true,
        retryable: retry
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    getRules() {
      let url = avatarApi(avatarApiUrls.getAvatarRulesUrl);

      let config = {
        url
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    setScales(scales) {
      let url = avatarApi(avatarApiUrls.setScalesUrl);

      let config = {
        url,
        withCredentials: true
      };
      return httpService.httpPost(config, scales);
    },

    setAvatarType(avatarType) {
      let url = avatarApi(avatarApiUrls.setAvatarTypeUrl);

      let config = {
        url,
        withCredentials: true
      };
      let params = {
        playerAvatarType: avatarType
      };
      return httpService.httpPost(config, params);
    },

    getRecentItems(type) {
      let url = avatarApi(avatarApiUrls.getRecentItemsUrl, { type });

      let config = {
        url,
        withCredentials: true,
        retryable: true
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    redrawThumbnail() {
      let url = avatarApi(avatarApiUrls.redrawThumbnailUrl);

      let config = {
        url,
        withCredentials: true,
        retryable: false
      };
      let params = {};
      return httpService.httpPost(config, params);
    },

    getMetaData(retry) {
      let url = avatarApi(avatarApiUrls.getMetaData);

      if (typeof retry === 'undefined') {
        retry = true;
      }
      let config = {
        url,
        withCredentials: true,
        retryable: retry
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    getCategories() {
      let url = catalogApi(catalogApiUrls.getCategories);

      let config = {
        url
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    getSubcategories() {
      let url = catalogApi(catalogApiUrls.getSubcategories);

      let config = {
        url
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    getEmotes() {
      let url = avatarApi(avatarApiUrls.getEmotesUrl);

      let config = {
        url
      };
      let params = {};
      return httpService.httpGet(config, params);
    },

    equipEmote(assetId, positionIndex) {
      var url = avatarApi(avatarApiUrls.equipEmoteUrl, {
        assetId: assetId,
        position: positionIndex
      });

      let config = {
        url
      };
      return httpService.httpPost(config);
    },

    unequipEmote(positionIndex) {
      let url = avatarApi(avatarApiUrls.unequipEmoteUrl, { position: positionIndex });

      let config = {
        url
      };
      return httpService.httpDelete(config);
    }
  };
}

avatarModule.factory('avatarService', avatarService);

export default avatarService;
